export const zhT = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: '新增文字',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: '新增至購物車',
  ADD_TEMPLATE: '新增範本',
  ADJUST_SIZE_KEY: '調整大小',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: '對齊底部',
  ALIGN_CENTER_KEY: '居中對齊',
  ALIGN_KEY: '對齊',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: '對齊中間',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: '頂部對齊',
  ALL_TAB_TITLE_KEY: '全部',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',

  BASIC_HELPER_INSTRUCTION1_KEY: '瀏覽內容並為設計選擇影像，或上傳您自己的影像',
  BASIC_HELPER_INSTRUCTION2_KEY: '預覽設計或調整細節',
  BASIC_HELPER_INSTRUCTION3_KEY: '自訂設計，並向專案中新增其他元素',
  BASIC_HELPER_INSTRUCTION4_KEY:
    '設計就緒之後，按「下一步」進行最終檢查並下訂單。',
  BACK_KEY: '返回',
  BACKGROUND_KEY: '背景',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: '在此類別下未找到任何靈感',
  BRING_TO_FRONT_KEY: '移到最上層',
  CANCEL_TEXT_KEY: ' 取消 ',
  CENTIMETERS_KEY: '公分',
  CM_KEY: '公分',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: '選擇檔案',
  CITY: 'City',
  CLEAR_ALL_KEY: '全部清除',
  CLEAR_COLOR_KEY: '清除色彩',
  CLOSE_WINDOW_KEY: '關閉視窗',
  CLEAR_ALL_OBJECTS: '清除所有物件',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: '這麼做會移除背景中的所有物件。',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: '色彩',
  CONTINUE_KEY: '繼續...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: '自訂',
  CUSTOM_PRICE_SIGN_IN_KEY: '登錄下一步，查看自定義定價。',
  CM_UNIT_KEY: '公分',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: '設計',
  DELETE_KEY: '刪除',
  DOCUMENT_COLORS: '文件顏色',
  DONE: 'Done!',
  DONE_KEY: '完成',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: '下載',
  DOWNLOAD_APP_TITLE_KEY: '您可以在此處下載應用程式：',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox 匯入',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime搜索',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime圖像',
  DUPLICATE_KEY: '複製',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: '編輯設計',
  EDIT_LOWERCASE_KEY: '編輯',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: '很抱歉，發生問題。請稍後再試一次。',
  ERROR_IN_OPENING_PDF_FILE_TEXT: '很抱歉，開啟已上傳的 PDF 檔案時發生問題。',
  EMAIL_KEY: '電子郵件',
  EMAIL_ADDRESS_KEY: '電子郵件地址:',
  EMAIL_CHECKBOX_MESSAGE:
    '我們知道此人瞭解將代表我或此服務提供者從 HP 接收電子郵件。',
  EXTRA_INFO_KEY: '額外資訊',
  EMAIL_NOTIFICATION:
    '不久後您就會收到電子郵件。處理時間約需 15 分鐘，請耐心等候。',
  EMAIL_DIALOG_MESSAGE: '輸入您想共用設計的使用者電子郵件地址。',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: '現有資料夾',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY: '繼續結帳前，請確定所有選取的項目均正確',
  FINAL_CHECK_TITLE_KEY: '最後檢查',
  FINISH_KEY: '完成',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: '翻轉',
  FOR_KEY: '對於',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: '關鍵字:',
  FOLDER_NAME: '資料夾名稱',
  FOLDER_NAME_KEY: '資料夾名稱:',
  FOLDER_ALREADY_EXIST_KEY: '此資料夾名稱已存在',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: '好的，我已瞭解',
  GROUP_ALL_KEY: '將全部組成群組',
  GROUP_SCALE: '群組縮放比例',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: '為專案命名',
  HEIGHT_KEY: '高度',
  HELP_KEY: '說明',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: '影像',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: '正在匯入',
  INCHES_COLUMN_HEADER_KEY: '英寸',
  INCHES_KEY: ' 英寸',
  INCHES_UNIT_STRING_KEY: '英寸',
  INVALID_EMAIL_ADDRESS_KEY: '無效的電子郵件地址',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: '無效的名稱',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    '很抱歉，您選取的檔案過大。檔案大小上限為 500mb。',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    '很抱歉，這不是有效的檔案格式。我們僅能處理 pdf、jpg、png、svg 和 tif 檔案。',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: '語言',
  LASTNAME: 'Last name',
  LEARN_MORE: '詳細瞭解',
  LEARN_THE_BASICS_KEY: '瞭解基本知識',
  LEGAL_FOOTER_MESSAGE1_KEY: '使用此網站即表示您同意遵守這些',
  LEGAL_FOOTER_MESSAGE2_KEY: '此網站遵守',
  LEGAL_FOOTER_MESSAGE3_KEY: '以及',
  LENGTH_STRING_IN_INCHES_KEY: '英寸',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    '若要視覺化正在新增的內容，請下載 LinkReader 應用程式。',
  LOADING_KEY: '載入中...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: '鎖定',
  LOGIN_KEY: '登入',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: '登錄Dreamstime',
  LOGOUT_KEY: '登出',
  MATERIAL_TITLE_KEY: '材質',
  MATERIAL_STRING_KEY: '材質',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    '覆蓋牆面的背景高度或寬度已達要求下限，無法繼續縮小背景比例。',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: '型號',
  MORE_INFO_TEXT_KEY: '更多資訊',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: '名稱:',
  NEXT_BUTTON_TITLE_KEY: '下一頁',
  NEW_FOLDER_KEY: '新資料夾',
  NO_SHADOW_KEY: '無陰影',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: '確定',
  ORDER_SAMPLE_KEY: '訂單樣本',
  ORDER_SAMPLE: '訂購範例',
  ORDER_SAMPLE_INFOLABEL_1: '選取您要做為樣本進行訂購的影像片段',
  ORDER_SAMPLE_INFOLABEL_2:
    '您將收到電子郵件，內含以實際大小顯示的專案特寫檢視。',
  ORDER_SAMPLE_INFOLABEL_3: '如此可協助您評估其品質與解析度',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: '立即訂購樣本',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    '接收以電子郵件所傳送用實際大小列印的專案特寫檢視圖，以評估其品質/解析度。',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: '密碼',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY: '我擁有此影像的版權且同意:',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: '像素',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: '公分',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY: '即部分重要事項需要與輸出中心溝通',
  PLACEHOLDER_INCHES_STRING_KEY: '英寸',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: '位置',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: '儲存專案',
  PRE_CHECK_SAVE_DIALOG_MESSAGE: '您必須先儲存專案變更才能繼續。',
  PRICE_COLUMN_HEADER_KEY: '價格',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: '處理中...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: '預覽',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: '專案名稱',
  PROJECT_NAME: '專案名稱:',
  PROJECT_ALREADY_EXIST_KEY: '此專案名稱已存在',
  NONUNIQUE_PROJECT_NAME_MESSAGE: '此專案名稱已存在',
  NONUNIQUE_FOLDER_NAME_MESSAGE: '此資料夾名稱已存在',
  PIXELATION_WARNING_KEY: '像素化警告',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    '由於您上傳的照片的分辨率，您的皮膚可能會變形或扭曲。為確保沒有模糊，請上傳高質量的圖像並避免圖像拉伸。如果您對預覽滿意並希望繼續，請繼續提交。',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: '必要',
  RECOLOR_KEY: '重新著色',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: '重新著色',
  REQUEST_SAMPLE_KEY: '請求樣本',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: '任意調整大小',
  RESIZE_PROPORTIONALLY_KEY: '按比例調整大小',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: '要求報價',
  RIGHT_LOGO_TEXT_KEY: '於',
  ROTATE_KEY: '旋轉',
  ROTATE_LEFT_KEY: '向左旋轉 90 度',
  ROTATE_RIGHT_KEY: '向右旋轉 90 度',
  ROTATION_KEY: '旋轉',
  ROWS_COLUMN_LABEL_STRING_KEY: '列數與欄數',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: '儲存',
  SAVING_KEY: '儲存中...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: '儲存範本',
  SAVE_DIALOG_TITLE: '儲存專案',
  SAVE_PROJECT_NAME_KEY: '請先儲存專案',
  SAVEDIALOG_MESSAGE:
    '請登入以儲存專案。如果您沒有帳戶，我們會協助您建立新帳戶。您的進度不會遺失。',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: '縮放影像以適應設計',
  SCALE_KEY: '縮放比例',
  SCALE_ALL_KEY: '全部縮放',
  SCALE_TO_FILL_KEY: '縮放以填滿',
  SEARCH_BUTTON_TITLE_KEY: '搜尋',
  SELECT_CUSTOM_SIZE_KEY: '選擇自訂大小',
  SELECT_CUSTOM_KEY: '自訂',
  SEARCH_TITLE: '搜尋',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: '選擇海報大小',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: '向我傳送安裝指示',
  SEND_TO_BACK_KEY: '移到最下層',
  SEND_KEY: '傳送',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: '設定大小',
  SETTINGS_KEY: '設定',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: '共用',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: '平方英尺',
  SQM_UNIT_STRING_KEY: '平方公尺',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: '提交',
  SHARE_LINK_LABEL: '選取您要共用的連結類型',
  SHARE_EDIT_LINK: '編輯連結',
  SHARE_VIEW_LINK: '檢視連結',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* 可從設定變更目標檢視距離。',
  TERMS1_KEY: '條款',
  TERMS2_KEY: 'HP 隱私權聲明',
  TERMS3_KEY: 'HP 個人資料權益須知',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: '使用條款。',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: '並排顯示',
  TOTAL_KEY: '總計',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: '謝謝您',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: '解除鎖定',
  UNGROUP_KEY: '取消群組',
  UPDATE_TEXT_KEY: '更新',
  UPLOAD_KEY: '影像上傳',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: '使用者名稱',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: '取消並排顯示',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: '有效期',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: '在 Fotolia© 中檢視',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: '檢視設計工具詳細資料',
  VIEW_DESIGNER_PROFILE_KEY: '檢視設計工具設定檔',
  VIEW_PRICE_KEY: '檢視價格',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: '掛牆海報',
  WALL_SIZE_TEXT_KEY: '牆面大小',
  WARNING_KEY: '警告',
  WEBSITE: 'Website',
  WIDTH_KEY: '寬度',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: '您的姓名',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: '您的專案:',
  PROJECT_NAME_ERROR_TEXT: '請輸入專案的名稱。',
  PROJECT_FOLDER_ERROR_TEXT: '請輸入專案資料夾的名稱。',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: '最小檢視距離',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: '找不到dreamtime內容',
  NO_ELEMENT_ERROR_MESSAGE: '找不到元素。',
  NO_MORE_IMAGES_FOUND_KEY: '找不到更多圖片',
  NO_PATTERN_ERROR_MESSAGE: '未找到圖樣。',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: '訊息:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    '您已將列印影像的比例放大到於 {0} {1}. 檢視時可能會產生模糊不清的馬賽克效果 (目前的列印解析度為 {2} dpi)。',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    '建議檢視距離為 {0} {1}。如果此距離不適當，請縮小此影像的比例或牆壁設計的大小。',
  ZOOM_WARNING_VALID_IMAGE_TEXT: '最小的影像大小建議應為 {0} x {1} 像素。',
  UPLOAD_STATUS: '{0}% MB (共 {1} MB)',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: '尺寸至少需為 {0} (寬) by {1} (高)。',
  MINIMUM_HEIGHT_KEY: '高度下限為 {0}。',
  MINIMUM_WIDTH_KEY: '寬度下限為 {0}。',
  MAXIMUM_DIMENSIONS_KEY: '最大尺寸為 {0} (w) * {1} (h)。',
  MAXIMUM_WIDTH_KEY: '寬度上限為 {0}',
  MAXIMUM_HEIGHT_KEY: '高度上限為 {0}',
  INVALID_NUMBER_ERROR_TEXT_KEY: '請插入大於 0 的尺寸數值。',
  PROCESSING_FAILED: '處理失敗，請稍後重試',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: '很抱歉，系統不支援多頁 PDF。',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: '抱歉，不支持加密的PDF。',
  DROPBOX_UPLOAD_PROGRESS_KEY: '正在匯入檔案 {0} 之 {1}',
  RECOLORING_KEY: '正在重新著色...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: '純色',
  AUTHENTICATE_DIALOG_TITLE: '此內容來源受密碼保護',
  AUTHENTICATE_FAILED_MESSAGE: '驗證失敗!',
  DROPBOX_IMPORT_ERROR_HEADER: '匯入部分檔案時發生問題',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: '頁面大小警告！',
  INSPIRATION_SIZE_CHANGE_WARNING:
    '該靈感模板的默認大小為{0} X {1} {2}。 您的頁面大小將自動更改以適合此模板。',
  MODIFY_SIZE_WARNING:
    '如果您希望調整此設計的大小，可以在“設置”選項卡中進行。 設計元素可能需要進行編輯以適應所需的尺寸。',
  RANDOMIZE_KEY: '随机化',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  MATERIAL_CHOICE_APPLIED: '應用材料選擇.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: '請輸入必填字段',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: '你的資料',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: '注意：',
  CAUTION_FOR_LAPTOP_SELECTION:
    '為了使PC皮膚完全適合您，您必須選擇與所購買產品相對應的確切型號，如發票所示。',
  RESTART_PROJECT_ALERT_TITLE: '重新啟動專案?',
  DISCARD_ALERT_MESSAGE: '將捨棄目前的專案',
  RESTART: '重新啟動',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: '證書',
  AUTHENTICITY_STRING: '真偽',
  PLEASE_WAIT: '請耐心等待',
  PROTECTING_YOUR_DATA: '保護您的數據...',
  SEARCH_YOUR_LAPTOP_KEY: '搜索您的筆記本電腦', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY: '糟糕！ 我們找不到適合您搜索的筆記本電腦。', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: '序列號',
  LOCKED_PROJECT: '鎖定的專案',
  LOCKED_MESSAGE: '此專案已經訂購，無法變更。您僅可檢視此專案。 ',
  EXPIRED_PROJECT: '過期的專案',
  EXPIRED_MESSAGE: '此專案已過期。',
  DELETED_PROJECT: '已刪除的專案',
  DELETED_MESSAGE: '此專案已刪除。',
  CHOOSE_GROUP_TYPE: '選取 {0} 類型',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: '請輸入大於 0 的數字。',
  SIZE_KEY: '大小',
  DISTANCE_FROM_KEY: '與門',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: '家具',
  FIXTURES_KEY: '固定裝置',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: '左',
  RIGHT_KEY: '右',
  DELETE_WALL_KEY: '刪除牆面',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: '選擇畫布類型',
  MAXIMUM_WALL_SIZE_KEY: '牆壁大小上限為 {0} 平方{1}。',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: '畫布高度超過壁面高度。',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: '畫布寬度超過壁面寬度。',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY: '目前寬度的最大欄寬為 {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: '目前高度的最大列高為 {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY: '壁面寬度小於畫布寬度。',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: '牆壁寬度至少要有 {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: '牆壁高度至少要有 {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    '壁面高度小於畫布高度。',
  MAXIMUM_WALL_HEIGHT_KEY: '牆壁高度上限為 {0} {1}.',
  FINISHING_KEY: '加工',
  MIRROR_KEY: '鏡射',
  NATURAL_KEY: '自然',
  ROWS_KEY: '列高',
  COLUMNS_KEY: '欄寬',
  DEFAULT_WALL_SIZE_KEY: '預設牆面大小',
  EDIT_KEY: '編輯',
  TOP_KEY: '最上層',
  BOTTOM_KEY: '最下層'
};
